import store from '@/store';

export default {
  checkAdmin(to, from, next) {
    const isAuth = !!store.state.adminToken;
    // eslint-disable-next-line
    console.log(store.state.adminToken);
    if (isAuth && to.path === '/admin/login') {
      next('/admin');
    } else if (!isAuth && to.path !== '/admin/login') {
      next(`/admin/login?redirect_path=${to.path}`);
    } else {
      next();
    }
  },
  checkSchool(to, from, next) {
    const isAuth = !!store.state.schoolToken;
    if (isAuth && to.path === '/school/sign') {
      next('/school');
    } else if (!isAuth && to.path !== '/school/sign') {
      next(`/school/sign?redirect_path=${to.path}`);
    } else {
      next();
    }
  },
  checkUser(to, from, next) {
    const isAuth = !!store.state.userToken;
    if (isAuth && to.path === '/signUp') {
      next('/');
    } else if (!isAuth) {
      if (to.path === '/register_mobile_sign' || to.query.status === 'register') {
        next(`/register_mobile_sign?redirect_path=${to.path}`);
      } else if (to.path !== '/signUp') {
        next(`/signUp?redirect_path=${to.path}`);
      }
    } else {
      next();
    }
  },
  checkExpert(to, from, next) {
    const isAuth = !!store.state.expertToken;
    if (isAuth && to.path === '/signUp') {
      next('/');
    } else if (!isAuth && to.path !== '/signUp') {
      next(`/signUp?redirect_path=${to.path}`);
    } else {
      next();
    }
  },
};



// WEBPACK FOOTER //
// ./src/plugins/checkSign.js